import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { z } from 'zod';
import { zodI18nMap } from 'zod-i18n-map';
import translations from '@/app/i18n/localesResources';

export const supportedLngs = {
    en: 'EN',
    fr: 'FR'
};

const arraySupportedLngs = Object.keys(supportedLngs);
arraySupportedLngs.push('dev');

const resources = translations();

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: false,
        lng: 'fr', // Remove later, used for tests
        fallbackLng: 'en',
        supportedLngs: arraySupportedLngs,
        resources,
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });
z.setErrorMap(zodI18nMap);

export default i18n;